<template>
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />
    <!--客户搜索筛选框-->
    <search-pop :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />
    <van-tabs v-model="active" @change="handleClick">
      <van-tab title="待审核"></van-tab>
      <van-tab title="审核通过"></van-tab>
      <van-tab title="审核不通过"></van-tab>
    </van-tabs>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" v-hasPermi="['scrm:customer:list']" @load="onLoad" v-if="list.length > 0 && loading === false">
      <van-cell v-for="(item,index) in list" :key="index">
        <div class="flex-between">
          <div>
            <div class="custName-wrap">
              <div class="custName">
                {{ item.custName }}
                <van-tag round type="warning" v-if="item.verifyStatus == 0 && $store.state.user.user.userId == item.applyUserId">待审核</van-tag>
              </div>
            </div>
            <div>
              <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.applyUserName">申请人：{{item.applyUserName}} 申请时间：{{item.applyTime}}</van-tag>
              <van-tag style="margin-right:5px" plain type="success" v-if="item.verifyUserName&&item.verifyStatus!=0">审核人：{{item.verifyUserName}} 审核时间：{{item.verifyTime}}</van-tag>
              <!-- <van-tag color="#999" style="margin-right:5px" plain v-if="item.verifyTime&&item.verifyStatus!=0&&item.content">意见：{{item.content}}</van-tag> -->
            </div>
            <div v-if="item.verifyTime&&item.verifyStatus!=0">
              <span style="color: #ccc; font-size: 12px;">意见：{{item.content == null ? '无' : item.content }}</span>
            </div>
          </div>
           <van-button round type="info" size="mini" @click="handleApply(item)" v-hasPermi="['admi:apply:batchApproval']"
            v-if="item.verifyStatus == 0 && $store.state.user.user.userId != item.applyUserId">&nbsp;&nbsp;&nbsp;审&nbsp;核&nbsp;&nbsp;&nbsp;</van-button>
           <!-- <span class="tips" v-if="item.verifyStatus == 0 && $store.state.user.user.userId == item.applyUserId"
           >&nbsp;待审核&nbsp;</span> -->
        </div>
      </van-cell>
    </van-list>
    <empty-component v-if="isEmpty" />
    <!-- 审核表单 -->
    <van-dialog v-model="auditOpen" title="客户申领审核" class="editVisit"  :beforeClose="submitApply" close-on-click-overlay>
      <br/>
      <van-form ref="auditForm" validate-trigger="onSubmit">
          <van-field name="radio" label="审核状态">
            <template #input>
              <van-radio-group v-model="auditForm.verifyStatus" direction="horizontal">
                <van-radio name="1">通过</van-radio>
                <van-radio name="2">不通过</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field v-model="auditForm.content" label="审核意见" type="textarea" :rules="[{ required: true }]" placeholder="请填写审核意见" required />
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
import { auditApply, listApply } from '@/api/scrm/mycust'
import { areaList } from '@vant/area-data'
import { getDicts } from '@/api/system/dict/data'
import SearchComponent from '@/components/common/Search'
import SearchPop from '../component/SearchPop.vue'
import EmptyComponent from '@/components/common/Empty'
import { Dialog, Toast, RadioGroup, Radio, Tab, Tabs } from 'vant'
export default {
  name: 'custClue',
  components: {
    SearchComponent,
    SearchPop,
    EmptyComponent,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs
  },
  data() {
    return {
      isEmpty: false,
      activeNames: [],
      picker: {
        visible: false,
        visibleIndustry: false,
        title: '',
        columns: [],
        formKey: '',
        areaList
      },
      active: 0,
      loading: false,
      finished: false,
      list: [],
      show: false,
      type: 'add',
      showFilterPop: false,
      searchValue: '',
      custList: [],
      options: {
        // 客户类型字典
        custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
        // 客户来源字典
        custSourceOptions: this.$store.state.dictOptions.custSource || [],
        // 客户状态
        custStatusOptions: this.$store.state.dictOptions.custStatus || []
      },
      form: {
        custType: null,
        custName: null
      },
      queryParams: {
        verifyStatus: '0',
        orderByColumn: 'createTime',
        isAsc: 'desc'
      },
      auditOpen: false,
      auditForm: {
        verifyStatus: '1',
        ids: []
      }
    }
  },
  created() {
    this.handleList()
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      document.title = '公海管理-申领审核'
    },
    QueryReset() {
      this.queryParams = {
        verifyStatus: '0',
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.QueryReset()
      this.queryParams.custName = this.searchValue = data
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryCustList()
    },
    queryCustList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.handleList()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },

    toCustBlueDetails(item) {
      this.$router.push(`/scrm/custManage/detail/${item.custId}`)
    },
    showPicker(type) {
      this.picker.formKey = type
      if (this.options.custTypeOptions.length) {
        if (type === 'custType') {
          this.picker.columns = this.options.custTypeOptions.map((ele) => ele.dictLabel)
        }
      } else {
        getDicts('crm_mycust_type').then(res => {
          this.options.custTypeOptions = res.data
          if (type === 'custType') {
            this.picker.columns = this.options.custTypeOptions.map((ele) => ele.dictLabel)
          }
        })
      }
      this.picker.visible = true
    },
    addCust() {
      this.show = true
    },
    async handleList() {
      this.loading = true
      const _this = this
      const res = await listApply(_this.queryParams)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          _this.isEmpty = true
        } else {
          _this.isEmpty = false
        }
        _this.list = _this.list.concat(...res.rows)
        _this.finished = _this.list.length >= res.total
        _this.loading = false
      }
    },
    onLoad() {
      this.handleList()
    },
    submitApply(type, done) {
      const that = this
      if (type === 'confirm') {
        try {
          Dialog.confirm({
            title: '审核提示',
            message: '是否确认审核？'
          }).then(function() {
            return auditApply(that.auditForm)
          }).then(() => {
            that.auditOpen = false
            Toast.success('审核成功')
            that.queryCustList()
          })
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    handleApply(row) {
      const ids = []
      if (row.highSeasApplyId) {
        ids.push(row.highSeasApplyId)
      }
      this.auditForm.ids = ids
      this.auditOpen = true
    },
    handleClick(tab, event) {
      this.queryParams.verifyStatus = tab || 0
      this.queryCustList()
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.van-tabs {
  position: relative;
  top: 1.25rem;
}
.tips{
  min-width: 3.1rem;
  font-size: .4rem;
  color: rgb(247, 155, 35);
}
/deep/ .van-tabs__line {
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}
.editVisit{
    min-height: 9rem;
    height: 50%;
    top: 46%;
    .formSty{
      height: 100%; overflow: scroll; margin: 10px 5px;
    }
}
.editVisit /deep/.van-dialog__content {
  height: 83%;
  .van-field--error .van-field__control{
    font-size: 0.38rem;
  }
  .van-field__control{font-size: 0.38rem;}
}
.editVisit /deep/.van-dialog__content {
  height: 70%;
}
</style>
